import { render, staticRenderFns } from "./CommonModal.vue?vue&type=template&id=88932cb2&scoped=true&"
import script from "./CommonModal.vue?vue&type=script&lang=ts&"
export * from "./CommonModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModal.vue?vue&type=style&index=0&id=88932cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88932cb2",
  null
  
)

export default component.exports